import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, Grid } from 'lucide-react'; // icons ????

function Sidebar() {
    const [isMastersOpen, setIsMastersOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMasters = () => {
        setIsMastersOpen(!isMastersOpen);
    };

    return (
        <div className="sidebar" style={{ width: '250px', background: '#fff', height: '100vh', borderRight: '1px solid #ddd' }}>

            {/* Masters Main Menu */}
            <div
                className="menu-item"
                onClick={toggleMasters}
                style={{
                    padding: '12px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    fontWeight: '500'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '20px' }}>??</span>
                    <span>Masters (?????????)</span>
                </div>
                {isMastersOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </div>

            {/* Dropdown Content */}
            {isMastersOpen && (
                <div className="dropdown-container" style={{ background: '#f9f9f9' }}>
                    <div
                        className="dropdown-item"
                        onClick={() => navigate('/department-master')}
                        style={{
                            padding: '10px 20px 10px 50px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#444',
                            transition: '0.3s'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#4c51bf'}
                        onMouseLeave={(e) => e.target.style.color = '#444'}
                    >
                        🏢 Departments (డిపార్ట్‌మెంట్స్)
                    </div>

                    <div
                        className="dropdown-item"
                        onClick={() => navigate('/banner-master')}
                        style={{
                            padding: '10px 20px 10px 50px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#444',
                            transition: '0.3s'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#4c51bf'}
                        onMouseLeave={(e) => e.target.style.color = '#444'}
                    >
                        🖼️ Banners (బ్యానర్స్)
                    </div>

                    {/* భవిష్యత్తులో మరిన్ని మాస్టర్స్ ఇక్కడ యాడ్ చేసుకోవచ్చు */}
                </div>
            )}

        </div>
    );
}

export default Sidebar;